<groundworks-modal>
  <groundworks-modal-header title="Foreman Detail" (cancelModal)="closeModal()" />
  <groundworks-modal-body>
    @if (isLoading()) {
      <groundworks-state-message type="loading" message="Loading foreman details..." />
    }
    @if (hasError() && !isLoading()) {
      <groundworks-state-message
        type="error"
        message="Failed to load foreman details. Please try again."
        [button]="retryButton"
      />
    }
    @if (!isLoading() && !hasError() && detail()) {
      <groundworks-term-value [items]="termValueItems()" layout="inline" />
    }
  </groundworks-modal-body>
  @if (!isLoading() && !hasError() && detail()) {
    <groundworks-modal-footer [actions]="footerActions()" />
  }
</groundworks-modal>
